// 調證模塊翻譯匯總
import recommendation from "./recommendation.js";
import uploadOld from "./uploadOld.js";
import investigation from "./investigation.js";

export default {
  recommendation,
  uploadOld,
  investigation,
};
